module.exports = __webpack_public_path__ + "static/media/usa-flag.7afe73c3.svg";